module.exports = __webpack_public_path__ + "static/media/simulation_yellow.ed37e88c.svg";